export function getDate(stringDate) {
    let publishDate = new Date(Date.parse(stringDate));
    return publishDate.toLocaleString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}
